import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import AuthProvider from './context/AuthContext.tsx' // FIXED: Use default import
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)